<template>
  <div class="Narration">
    
   <!--  <div class="Narration__ico">
      
      <img :src="require('./img/on.png')" />

    </div>
 -->

  </div> 
</template>
<script>
import {Howl, Howler} from 'howler'
import frJSON from './audio/fr/momenta.json'
import enJSON from './audio/en/momenta.json'
// import Cookies from 'js-cookie'
import Settings from '@/config/Settings'

// let isActive = eval(Cookies.get(Settings.cookies.sound))
// if(isActive === undefined)
//   isActive = true

export default {

  name: 'Narration',
  beforeDestroy() {
    this.$sound.unload()
  },
  data: () => ({
    // active: isActive,
    // ambianceName: 'ambiance-musee-before-secret',
    // ambianceID: null,
    // ambianceVolume: .2
  }),
  beforeCreate() {

    this.$fr = new Howl({
      src: [require('./audio/fr/momenta_fr.mp3')],
      sprite: frJSON.sprite
    })
    this.$en = new Howl({
      src: [require('./audio/en/momenta_en.mp3')],
      sprite: enJSON.sprite
    })

    console.log('Narration!');

    // Howler.mute(isActive ? false : true)
  },
  computed: {
    route() { return this.$store.getters['app/route'] },
    narration_muted() { return this.$store.getters['app/narration_muted'] }
  },
  watch: {
    '$route': {
      immediate: true,
      handler() {
        // if(this.slugIsIn(['monde', 'monde:1', 'monde:2']) || this.$route.meta.name == 'artwork')
        //   return

        if(this.route.to.params.page || this.route.from.params.page)
          return

        this.$fr.stop()
        this.$en.stop()
        this.$sound = (this.lang == 'fr') ? this.$fr : this.$en

        if(this.$route.meta.name == 'artwork')
          return

        const regex = /:/gi
        let sound = this.$route.params.slug.replace(regex, '_')

        this.$sound.stop()
        if(this.$tween) this.$tween.kill()
        this.$tween = TweenMax.delayedCall(1, ()=>{ 
          this.$id = this.$sound.play('sound_'+ sound) 
          if(this.narration_muted)
            this.$sound.mute(true, this.$id)
        })
      }
    },
    narration_muted(nw, od) {
      if(this.$id)
        this.$sound.mute(nw, this.$id)
    },
  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Narration
  position fixed

</style>












// WEBPACK FOOTER //
// src/components/narration/Narration.vue